import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RequestPoint } from 'src/app/interfaces/api/point';
import { PointService } from 'src/app/services/point.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-point-history',
  templateUrl: './point-history.component.html',
  styleUrls: ['./point-history.component.scss'],
})
export class PointHistoryComponent implements OnInit {
  @Input() isLoading: boolean;
  sortAscending = false;
  history: RequestPoint;

  constructor(private router: Router, private pointService: PointService) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    const pointReq = this.pointService.getPointHistory();
    forkJoin([pointReq]).subscribe({
      next: async ([pointRes]) => {
        this.history = pointRes;
        this.isLoading = false;
        console.log(this.history);
      },
    });
  }

  toggleSortOrder() {
    this.sortAscending = !this.sortAscending;
    this.history?.points.data.sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      const sortOrder = this.sortAscending ? 1 : -1;

      return sortOrder * (dateA - dateB);
    });
  }
}
